import * as videosService from '@/services/videos'

const state = () => ({
  list: [],
  videoPage: null,
})

// getters
const getters = {
  videos: (state: any) => state.list,
}

// actions
const actions = {
  async fetchVideos({ commit, state }: any, data: any) {
    const videos = await videosService.fetchVideos(data)
    // commit('setVideoPage', videos.page)
    // commit('setVideos', videos.data)
    if (videos.data.list) {
      commit('setVideoPage', videos.data)
      commit('setVideos', videos.data.list)
    }
  },
}

// mutations
const mutations = {
  setVideos(state: any, videos: object) {
    if (state.list && state.list.length && state.videoPage.currPage != 1) {
      state.list = state.list.concat(videos)
    } else {
      state.list = videos
    }
  },
  setVideoPage(state: any, page: object) {
    if (page) {
      state.videoPage = page
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
